import React from 'react';
import PropTypes from 'prop-types';
import Description from './Description';

import { SingleSlider } from '../../../../Sliders/index';
import { MapsLinkIcon } from '../../../../Maps/index';
import { truncText } from '../../../../../utils/formater';

class DescriptionAndType extends Description {
  renderServices () {
    const trusted = this.item.getAuthor().isTrusted();

    return (
      <div className='service-icon-wrp'>
        {
          this.item.isPremium()
            ? <span data-tip data-for='tip-premium' className='icon-premium'><span className='path1' /><span className='path2' /></span>
            : (this.item.isPromo() && <span data-tip data-for='tip-promo' className='icon-promo'><span className='path1' /><span className='path2' /></span>)
        }
        { trusted && <span data-tip data-for='tip-trusted' className='icon-trusted' /> }
      </div>
    );
  }

  render () {
    const property = this.item.getProperty();
    const type = property.getType();
    const geoLocation = property.getGeoLocation();
    const distance = geoLocation.getDistanceFromCity();

    return (
      <td className='col-description'>
        <a className='slider-container' href={this.item.getLink()} target='_blank'>
          <SingleSlider
            className='property-grid-slider'
            photos={this.item.getPhotos()}
            photoSize='320x240'
            showPhotoCount />
        </a>

        <div className='content-container'>
          <a target='_blank' className='location slim' href={this.item.getLink()}>
            { type && (<span className='main-param'>{type.get('middleName')},&nbsp;</span>) }
            {geoLocation.getShortAddress()}
          </a>

          <MapsLinkIcon realtyObject={this.item} eventMapModal={this.props.eventMapModal} />

          { this.renderLocation() }
          { this.renderComplex() }

          { distance && (<div>{'Удаленность от города: ' + distance + ' км.'}</div>) }

          <div onClick={this.handlerOpenDescriptionModal}>{ truncText(this.item.getDescription(), distance ? 120 : 160) }</div>

          { this.renderControls() }
          { this.renderServices() }
        </div>

        { this.renderModal() }
      </td>
    );
  }
}

DescriptionAndType.propTypes = {
  item: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  domain: PropTypes.object.isRequired,

  eventAddFavorites: PropTypes.func,
  eventRemoveFavorites: PropTypes.func,
  eventOpenCommentForm: PropTypes.func,
  eventOpenClaimForm: PropTypes.func,
  eventMapModal: PropTypes.func
};

DescriptionAndType.defaultProps = {
  eventAddFavorites: id => {},
  eventRemoveFavorites: id => {},
  eventOpenCommentForm: id => {},
  eventOpenClaimForm: id => {},
  eventMapModal: id => {}
};

export default DescriptionAndType;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/GridCells/DescriptionAndType.jsx